module.exports = __webpack_public_path__ + "img/Groupgray.bd1bd5d2.svg";